
export async function api(target, formData, method = 'POST'){
	
	let data = Array();
	
	try {
		data = await fetch(target, {
			method: method,
			headers: {
					'Accept': 'application/json'
			},
			body:formData
		}).then((e) => {
			return e.json();
		});
		
		return data;
	} catch (error) {
		data.error = "API Fail";
		console.error('Error ***', error);
		
		return data;
	}
	
}